import React, { useMemo } from 'react'
import { ThemeProvider, useTheme } from '@mui/material/styles'
import { createAdvancedTheme } from './theme'

type Props = { children: React.ReactNode }

const AdvancedThemeProvider = ({ children }: Props) => {
  const base = useTheme()
  const theme = useMemo(() => createAdvancedTheme(base), [base])

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default AdvancedThemeProvider
